import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolingTasksComponent } from './tooling-tasks/tooling-tasks.component';
import { Route } from '@angular/router';
import {
  GridV2Module,
  RadioV2Module,
  ButtonV2Module,
  ModalModule,
  PagesV2Module,
  SpinnerV2Module,
  AssetsModule,
  TileV2Module,
  WorkflowModule,
  FormsModuleV2,
  SelectV2Module,
  FileUploadV2Module,
  MultiselectV2Module,
  CheckboxV2Module,
  NotificationsV2Module,
} from '@schenck/rotec-components';

import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { ToolingTaskSearchService, ToolingTaskSearchApi } from './tooling-task-search.service';
import { ToolingTaskSettingsApi } from './tooling-task-settings.api';
import { ToolingTaskSettingsService } from './tooling-task-settings.service';
import { ChooseToolingTaskOptionModalComponent } from './choose-tooling-task-option-modal/choose-tooling-task-option-modal.component';
import { UpsertToolingTaskWizardComponent } from './upsert-tooling-task-wizard/upsert-tooling-task-wizard.component';
import { FormsModule as AngularFormsModule } from '@angular/forms';
import { ToolingTaskModalComponent } from './tooling-task-modal/tooling-task-modal.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { toolingStepsComponents } from './upsert-tooling-task-wizard/steps/index';

export const toolingTasksRoutes: Route[] = [{ path: '', component: ToolingTasksComponent }];

@NgModule({
  imports: [
    CommonModule,
    AngularFormsModule,
    TranslatePipe,
    TranslateDirective,
    GridV2Module,
    RadioV2Module,
    ButtonV2Module,
    ModalModule,
    MultiselectV2Module,
    CheckboxV2Module,
    PagesV2Module,
    SpinnerV2Module,
    MatExpansionModule,
    FileUploadV2Module,
    AssetsModule,
    NotificationsV2Module,
    TileV2Module,
    WorkflowModule,
    FormsModuleV2,
    SelectV2Module,
    ToolingTasksComponent,
    ChooseToolingTaskOptionModalComponent,
    UpsertToolingTaskWizardComponent,
    ToolingTaskModalComponent,
    ...toolingStepsComponents,
  ],
  providers: [
    ToolingTaskSettingsApi,
    ToolingTaskSettingsService,
    ToolingTaskSearchApi,
    ToolingTaskSearchService,
  ],
})
export class ToolingTasksModule {}
